import React, { useContext, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import {Tooltip, Typography } from "@mui/material";
import { FiPlus } from "react-icons/fi";
import IconButton from "@mui/material/IconButton";
import ProjectList from "./ProjectList";
import { ProjectContext } from "../../../contexts/ProjectContext";
import { PRIMARY_COLOR_DarkNavyBlue} from "../../../constants/Colors";

const useStyles = makeStyles({
  titleContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: 10,
  },
  itemTitleText: {
    lineHeight: 0.5,
    marginRight: 5,
  },
});

export default function ProjectCategory({ category, index }) {
  const classes = useStyles();
  const { allProject, onAddProducts, setCategoryId, fetchCategory,
    fetchProjects, setProjectCategory } = useContext(ProjectContext);

  useEffect(() => {
    fetchCategory();
    fetchProjects();
  }, []);


  return (
    <>
      <div
        className={classes.titleContainer}
        style={{ marginTop: index === 0 ? 0 : 40 }}
      >
        <Typography
          variant={"h5"}
          className={classes.itemTitleText}
          id={"title1"}
        >
          {
              category.categoryName.charAt(0).toUpperCase() + category.categoryName.slice(1)
          }
        </Typography>
        <Tooltip title="Add Projects">
          <IconButton
            style={{
              backgroundColor: PRIMARY_COLOR_DarkNavyBlue,
              color: "#fff",
              marginLeft: 5,
            }}
            variant={"contained"}
            onClick={() => {
              onAddProducts();
              setCategoryId(category.categoryId);
              setProjectCategory(category.categoryName)
            }}
          >
            <FiPlus size={18} />
          </IconButton>
        </Tooltip>
      </div>
      <ProjectList categoryProjects={category.projects} categoryId={category.categoryId} categoryName={category.categoryName} projects={allProject} />
    </>
  );
}
